import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import './bloomreach-recommendations-engine';
import './bloomreach-recommendations-model-carousel-engine';
import { BloomreachService } from './bloomreach.service';

export function provideBloomreach(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(BloomreachService).appInitialize();
        })
    ]);
}
